import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import NonOpsDetailContMain from "presentation/view/container/NonOps/NonOpsDetailContMain";

CommonEntrypoint(<NonOpsDetailContMain/>)